import React from "react";
import styles from "./BurgerMenuButton.module.scss";

interface BurgerMenuButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

export const BurgerMenuButton: React.FC<BurgerMenuButtonProps> = ({ onClick, isOpen }) => {
  return (
    <button
      className={`${styles.burgerButton} ${isOpen ? styles.active : ""}`}
      onClick={onClick}
      aria-label="Меню"
      type="button"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
};
